<template>
  <div class="edit_entry_qrcode_mask">
      <el-card class="box_content">
        <div slot="header" class="clearfix" style="text-align:center;">
            <span style="line-height: 36px;">添加资源</span>
        </div>
        <div class="resourseContent">
            <p>
                <span class="col-lg-3">选择文件：</span>
                <el-upload
                    ref="upload"
                    class="col-lg-4"
                    action="http://upload.qiniu.com/"
                    :data="myForm"
                    method="post"
                    :on-preview="handlePreview"
                    name="file"
                    :on-remove="handleRemove"
                    :before-upload="handleBeforeUpload"
                    :on-success="handleSuccess"
                    :multiple="isMultiple"
                    :file-list="fileList">
                    <el-button size="small" type="primary">选择文件</el-button>
                </el-upload>
            </p>
            <p>
                <span class="col-lg-3">资源路径：</span><span class="col-lg-4">{{distributionQrcodeUrl}}</span>
            </p>
            <p style="text-align:center;"><el-button type="success" :loading="loading" @click="commit" style="width: 240px;">提交</el-button></p>
        </div>
        <span @click="boxColose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
      </el-card>
  </div>
</template>
<script>
import $ajax from '../../https/config'
import { isNull } from '../../js/tool'
export default {
  props: ['deviceCode'],
  data () {
    return {
      loading: false,
      fileList: [],
      fileNum: 0,
      form: {},
      distributionQrcodeUrl: '',
      isMultiple: false,
      token: ''
    }
  },
  computed: {
    myForm: {
      set: function (value) {
        this.form = value
      },
      get: function () {
        return this.form
      }
    }
  },
  created: function () {
    this.getUpToken()
  },
  methods: {
    boxColose () {
      this.$emit('closeEditEntryBox', false)
    },
    commit () {
      if (isNull(this.deviceCode)) {
        _this.$message({
          type: 'error',
          message: '没有设备表面错误，请退出后重试'
        })
        return false
      }
      if (isNull(this.distributionQrcodeUrl)) {
        _this.$message({
          type: 'error',
          message: '请选择入口二维码'
        })
        return false
      }
      var _this = this
      var params = {
        deviceCode: this.deviceCode,
        distributionQrcode: this.distributionQrcodeUrl
      }
      this.loading = true
      $ajax.get('/para/addDistributionQrcode', params, 'headers', function (res) {
        if (res.resultStatus === true) {
          _this.$message({
            type: 'success',
            message: '修改入口二维码成功！'
          })
          _this.loading = false
          _this.boxColose()
        } else {
          _this.$message({
            type: 'error',
            message: '修改入口二维码失败！'
          })
          _this.loading = false
        }
      }, function () {
        _this.$message({
          type: 'error',
          message: '服务器异常'
        })
        _this.loading = false
      })
    },
    handlePreview (file) {

    },
    handleRemove (file, fileList) {
      if (fileList.length === 0) {
        this.distributionQrcodeUrl = ''
        this.fileNum = 0
      }
    },
    handleBeforeUpload (file) {
      var last, tType
      tType = 'image-'
      last = file.name.split('.').pop()
      if (this.fileNum >= 1) {
        this.$message({
          type: 'error',
          message: '一次只能上传一张图片'
        })
        return false
      }
      if (last !== 'jpg' && last !== 'png' && last !== 'jpeg') {
        this.$message({
          type: 'error',
          message: '图片格式错误'
        })
        return false
      }
      if (file.size / 1024 > 1024) {
        this.$message({
          type: 'error',
          message: '图片大小超过500KB'
        })
        return false
      }
      var str = tType + (new Date().getTime()) + Math.ceil(Math.random() * 10) + '.' + last
      this.form.key = str
    },
    handleSuccess (response, file, fileList) {
      this.distributionQrcodeUrl = 'http://' + 'image' + '.songzb.com/' + response.key
      this.fileNum = 1
    },
    getUpToken () {
      var myUrl = 'http://platform.songzb.com:32000/qiniuToken/image'
      var _this = this
      $ajax.get(myUrl, '', '', function (res) {
        _this.form.token = res.uptoken
      }, function () {
      })
    }
  }
}
</script>

<style lang="scss">
  .edit_entry_qrcode_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: absolute;
      background: rgba(#000, 0.3);
      z-index: 1001;
      text-align: center;
  
    .box_content {
        min-height: 300px;
        width: 500px;
        top: 40%;
        margin-top: -150px;
        left: 50%;
        z-index: 1002;
        margin-left: -250px;
        position: absolute;
        background: white;
        border-radius: 10px;
        -webkit-box-shadow: 0px 0px 10px wheat;
        box-shadow: 0px 0px 10px wheat;

        p {
            text-align: left;
        }

        .col-lg-3 {
            width: 20%;
            display: inline-block;
            font-weight: 700;
            color: #777;
            vertical-align: top;
        }
        .col-lg-4 {
            width: 72%;
            display: inline-block;

            textarea {
            height: 120px;
            }
        }
    }
  }
</style>


// WEBPACK FOOTER //
// src/page/deviceMgr/editEntryQrcodeBox.vue